import { query } from "firebase/database";
import { collection, getDocs, getFirestore, where } from "firebase/firestore";
import { motion } from "framer-motion";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import homeImageBackground from "../../assets/images/homeBackground.png";
import Header from "../../components/Header";
import { auth } from "../../config/firebase.js";
import { setAllDataForTokens } from "../../redux/tokens";
import Layout from "../../components/Layout.jsx";
import { Dark_White_mode } from "../../utils/constants.js";

const SuccessPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const currentUser = auth.currentUser;

  const getData = async () => {
    const db = getFirestore();
    const usersCollection = collection(db, "Users");
    const userId = currentUser?.uid;

    try {
      const q = query(usersCollection, where("userId", "==", userId));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        querySnapshot.forEach((doc) => {
          const userData = doc.data();
          console.log(userData);
          dispatch(setAllDataForTokens({...userData?.tokens, ...userData?.subscriptionData}));
        });
      } else {
        console.log("User not found");
      }
    } catch (error) {
      console.error("Error retrieving user:", error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      getData();
      navigate("/discover-dishes");
    }, 2000);
  }, []);
  return (
    <Layout setHeight={false}>
      <div className="flex items-center justify-center w-full h-[400px]">
        <p className={`${Dark_White_mode} text-3xl`}>Payment Successfull</p>
      </div>
    </Layout>
  );
};

export default SuccessPage;
